import { fetchCheckoutUrl } from './fetch-checkout-url';
import { combineUrl } from './utilities/combine-url';
export var addToCart = function (sku) {
    fetchCheckoutUrl()
        .then(function (checkoutUrl) {
        var references = Array.isArray(sku) ? sku.join(',') : sku;
        window.location.href = combineUrl(checkoutUrl, {
            action: 'add',
            externalReferenceId: references,
        });
    });
};
